export default {"src":"/_next/static/media/Research_Summaries.0fcf2f8e.svg","height":284,"width":284};